<page-load-header *ngIf="!initialized"></page-load-header>


<rundna-basic-website-wrapper>
  <gait-analysis-result-details [isCoachView]="false" [isShared]="true"></gait-analysis-result-details>

</rundna-basic-website-wrapper>


